/**
 * P3-31: MultiLink 按钮（sacrifice unicorns / alicorns / refine TCs）。
 *
 * 渲染 all / half / fifth links，行为对齐 religion.js:2207-2220。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import type { GameButtonLinkModel } from "../../components/GameButton";
import type { UseMultiLinkButtonModelResult } from "./useReligionModel";

interface MultiLinkButtonProps {
  model: UseMultiLinkButtonModelResult;
}

export function MultiLinkButton({ model }: MultiLinkButtonProps) {
  const { snap, modelRef, controller, getTooltip } = model;

  const onClick = useCallback(
    (event: MouseEvent) => {
      if (controller && modelRef.current) {
        controller.buyItem?.(modelRef.current, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  const links: GameButtonLinkModel[] = snap.links.map((link) => ({
    title: link.title,
    visible: link.visible,
    handler: link.handler,
  }));

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      links={links}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
